import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

/**
 * Resolves when the initial 'aita' namespace load settles — success OR failure
 * (every t() call carries an inline English default, so rendering can proceed
 * either way). Bootstrap awaits this before the first render: AppShell and the
 * route-level Suspense fallback both call useTranslation, and with
 * useSuspense:true an unsettled load would suspend them with no safe boundary
 * above (blank screen instead of the fallback).
 */
export const i18nReady: Promise<unknown> = i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    ns: ['aita'],
    defaultNS: 'aita',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: true,
    },
  })
  .catch(() => undefined);

export default i18n;
